import type {
	DocumentEditorTabs,
	DocumentEditorTabsParams,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentsModal/components/documentRowEditor.types';

/**
 * Which jobs the shared document editor has for this template. It carries both as tabs, so one
 * button opens it and each tab appears only where that job applies — the same gating
 * `MasterDocumentForm` uses, so a document offers the same editor from either place.
 */
export const getDocumentEditorTabs = ({
	isDocx,
	canPlaceSignaturesManually,
	canPersonaliseFields,
	postDatingEnabled,
}: DocumentEditorTabsParams): DocumentEditorTabs => {
	// A settings lock does not withhold the tab: the editor takes a `blockedReason` and says why
	// placement is frozen, which is more use than the tab quietly disappearing.
	const showSignaturesTab = !isDocx && (canPlaceSignaturesManually || postDatingEnabled);

	return {
		showFieldsTab: canPersonaliseFields,
		showSignaturesTab,
		// A Word template is the document itself, so it always has prose to edit.
		hasWork: isDocx || canPersonaliseFields || showSignaturesTab,
	};
};
